module.exports = __webpack_public_path__ + "static/media/combat(15).5c0b04ed.PNG";